// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"212":"54358eda","789":"9da0fddf"}[chunkId] + ".chunk.css";
};